var Enumerable = require("linq");

Array.prototype.Enumerable = function <T>() {
    let array: Array<T> = this;
    return Enumerable.from(array);
}

export class ArrayExtends{}
